function numberValidator({ input, msgs }) {
  const rule = /^[0-9]+(\.[0-9]+)?$/;

  if (!rule.test(input)) {
    return (msgs && msgs.msg) || 'Value must be numeric digits only.';
  }

  return null;
}

export default numberValidator;
